import { Typography } from "@mui/material";
import { PrimaryButton } from "Components/Shared/Buttons/PrimaryButton";
import { Resources, useResource } from "Translations/Resources";

const PAGE_RESOURCES = Resources.Hunter.LicensePaymentPending;

type Props = {
  onOrderLicense: () => void;
};

// The "no order yet" half of the blocked screen — points straight to ordering.
export const NoLicenseContent = ({ onOrderLicense }: Props) => {
  const { t } = useResource();

  return (
    <>
      <Typography variant="body1">{t(PAGE_RESOURCES.NoLicenseInfo)}</Typography>
      <PrimaryButton
        color="primary"
        variant="contained"
        fullWidth
        onClick={onOrderLicense}
      >
        {t(PAGE_RESOURCES.OrderLicense)}
      </PrimaryButton>
    </>
  );
};
